/**
 * Estadísticas anuales en profile.privateData.annual_stats (JSON por año).
 * Ej.: { "2023": { revenue: 9800.5, bookings: 9, url: "https://..." }, "2024": { ... } }
 */

const safeHttpUrl = raw => {
  if (typeof raw !== 'string') {
    return null;
  }
  const trimmed = raw.trim();
  if (!trimmed) {
    return null;
  }
  try {
    const u = new URL(trimmed);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') {
      return null;
    }
    return u.href;
  } catch {
    return null;
  }
};
export const getAnnualStatsFromUser = user => {
  const raw = user?.attributes?.profile?.privateData?.annual_stats;
  if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) {
    return null;
  }
  return raw;
};

export const userHasAnnualStats = user => {
  const stats = getAnnualStatsFromUser(user);
  if (!stats) {
    return false;
  }
  return Object.keys(stats).length > 0;
};

/**
 * @returns {{ year: string, revenue: number, bookings: number, certificateUrl: string | null }[]} ordenado año desc
 */
export const annualStatsToRows = stats => {
  if (!stats || typeof stats !== 'object') {
    return [];
  }
  return Object.keys(stats)
    .filter(y => /^\d{4}$/.test(String(y)))
    .sort((a, b) => Number(b) - Number(a))
    .map(year => {
      const row = stats[year];
      const revenue =
        row && typeof row.revenue === 'number' && !Number.isNaN(row.revenue) ? row.revenue : null;
      const bookings =
        row && typeof row.bookings === 'number' && Number.isFinite(row.bookings)
          ? row.bookings
          : row && row.bookings != null
          ? Number(row.bookings)
          : null;
      const certificateUrl = safeHttpUrl(row?.url);
      return {
        year,
        revenue,
        bookings: Number.isFinite(bookings) ? bookings : null,
        certificateUrl,
      };
    });
};
